export default function Drawer() {
	return {
		MuiDrawer: {
			styleOverrides: {
				paper: {
					border: 'none',
				},
			},
		},
	};
}
